'use strict';

module.exports = require('./lib/ReactDOMServer');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dom/server.js
 ** module id = 536
 ** module chunks = 1
 **/